import React, { lazy } from 'react';

type ReactComponentImport = {
  default: React.ComponentType;
  [name: string]: React.ComponentType;
};

export default class BatchComponentLoader {
  private importFunction: () => Promise<ReactComponentImport>;
  private loadedPages: ReactComponentImport | undefined;

  constructor(importFunction: () => Promise<ReactComponentImport>) {
    this.importFunction = importFunction;
  }

  private getPages = async (): Promise<ReactComponentImport> => {
    if (this.loadedPages !== undefined) return this.loadedPages;
    this.loadedPages = <ReactComponentImport>await this.importFunction();
    return this.loadedPages;
  };

  private getModule = async (moduleName: string): Promise<{ default: React.ComponentType }> => {
    const pages = await this.getPages();
    return { default: pages[moduleName] || pages.default };
  };

  public lazyLoad(moduleName: string): React.ComponentType {
    return lazy(() => this.getModule(moduleName));
  }
}
